import { useContext, createContext, useMemo, useState, useEffect, useCallback } from 'react';

//Context
export const ThemeContext = createContext(null);

//Provider
export const ThemeContextProvider = ({ children }) => {

  const [theme, setTheme] = useState('light');
  const [componentMounted, setComponentMounted] = useState(false);

  const setMode = (mode) => {
    window.localStorage.setItem('theme', mode);
    setTheme(mode);
  };

  const toggleTheme = useCallback(() => {
    setTheme(prevTheme => {
      const newTheme = prevTheme === 'light' ? 'dark' : 'light';
      window.localStorage.setItem('theme', newTheme);
      return newTheme;
    });
  }, []);

  useEffect(() => {
    const localTheme = window.localStorage.getItem('theme');
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && !localTheme) {
      setMode('dark');
    } else if (localTheme) {
      setTheme(localTheme);
    } else {
      setMode('light');
    }
    setComponentMounted(true);
  }, []);

  const values = useMemo(() => ({
    theme,
    toggleTheme,
    componentMounted,
  }), [theme, componentMounted, toggleTheme]);

  // Interfaz donde será expuesto como proveedor y envolverá la App.
  return <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>;
};

// Consumidor
export function useThemeContext() {
  const context = useContext(ThemeContext);

  if (!context) {
    console.error('Error deploying App ThemeContext!!!');
  }

  return context;
}

export default useThemeContext;

